import React from "react";
import Column from "@components/column";
import Title from "@components/title";
import NotificationHistoryList from "@commons/push-notifications/history";

const NotificationsPage = () => {
  return (
    <Column>
      <Title textone="All" texttwo="Notifications" />
      <div style={{ marginTop: "20px" }}>
        <NotificationHistoryList />
      </div>
    </Column>
  );
};

export default NotificationsPage;
